import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";

const RenderChecklist = ({
  data,
  handleSave,
  handleStoreData,
  formData,
  selectedData,
  setSelectedData,
}) => {
  // Function to convert image to base64
  const handleImageUpload = (idx, file) => {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        handleStoreData(idx, "image", reader.result);
      };
    }
  };

  return (
    <Box p={1}>
      {/* Compact Unit Code and Employee Code Input Fields */}
      <Box display="flex" gap={1} mb={1}>
        <TextField
          label="Unit Code"
          variant="outlined"
          size="small"
          value={selectedData.unitCode || ""}
          onChange={(e) =>
            setSelectedData((prev) => ({
              ...prev,
              unitCode: e.target.value,
            }))
          }
          fullWidth
        />
        <TextField
          label="Employee Code"
          variant="outlined"
          size="small"
          value={selectedData.empCode || ""}
          onChange={(e) =>
            setSelectedData((prev) => ({
              ...prev,
              empCode: e.target.value,
            }))
          }
          fullWidth
        />
        <TextField
          label="Remark"
          variant="outlined"
          size="small"
          placeholder="Enter remark"
          value={selectedData.remark || ""}
          onChange={(e) =>
            setSelectedData((prev) => ({
              ...prev,
              remark: e.target.value,
            }))
          }
          fullWidth
        />
        <TextField
          variant="outlined"
          size="small"
          type="datetime-local"
          value={selectedData.dateValue || ""}
          onChange={(e) =>
            setSelectedData((prev) => ({
              ...prev,
              dateValue: e.target.value,
            }))
          }
          fullWidth
        />
      </Box>

      {data.map((obj, idx) => (
        <Card
          key={obj.checklistid}
          variant="outlined"
          sx={{ mb: 0.5, p: 0.5, boxShadow: 0 }}
        >
          <CardContent
            sx={{
              p: 0.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{ minWidth: 120 }}
            >
              {obj.MasterName}
            </Typography>

            {/* Compact Dropdown for Yes/No */}
            <FormControl size="small" sx={{ minWidth: 100 }}>
              <Select
                value={formData[idx]?.status || ""}
                onChange={(e) => handleStoreData(idx, "status", e.target.value)}
                displayEmpty
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="1">Yes</MenuItem>
                <MenuItem value="0">No</MenuItem>
              </Select>
            </FormControl>

            {/* Image Upload if Status is 'Yes' */}
            {formData[idx]?.status === "1" && (
              <Box>
                <input
                  type="file"
                  accept="image/*"
                  style={{ fontSize: "0.7rem" }}
                  onChange={(e) => handleImageUpload(idx, e.target.files[0])}
                />
              </Box>
            )}
          </CardContent>
        </Card>
      ))}

      {/* Compact Save Button */}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        size="small"
        sx={{ mt: 1 }}
        onClick={handleSave}
      >
        Save
      </Button>
    </Box>
  );
};

export default RenderChecklist;
